var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-download-nested-document-dialog-vue',{attrs:{"show":_vm.show,"is-busy":_vm.isBusy,"format":"Docx","show-without-images-option":""},on:{"close":function($event){return _vm.$emit('close')},"download":_vm.downloadDocx}})}
var staticRenderFns = []

export { render, staticRenderFns }